import { FileText, Home, Image, LogOut, MapPin, Users, HeartPlus } from "lucide-react";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import * as api from "../api/api";
import "./AdminDashboard.css";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const { locationSlug } = useParams();
  const routerLocation = useLocation();
  const [selectedLocation, setSelectedLocation] = React.useState(() => {
    // Priority: navigation state -> URL param -> saved preference -> default
    const fromState =
      routerLocation?.state && routerLocation.state.selectedLocation;
    const fromSaved = window.localStorage.getItem("admin:selectedLocation");
    return fromState || locationSlug || fromSaved || "paris-11";
  });
  const [list, setList] = React.useState([]);

  React.useEffect(() => {
    let mounted = true;
    const fetch = async () => {
      try {
        const res = await api.getLocations();
        if (mounted && res) setList(res);
      } catch (err) {
        console.error("Failed to load locations for admin dashboard", err);
      }
    };
    fetch();
    return () => {
      mounted = false;
    };
  }, []);

  // keep selection persisted so returning to dashboard keeps last chosen cabinet
  React.useEffect(() => {
    try {
      if (selectedLocation)
        window.localStorage.setItem("admin:selectedLocation", selectedLocation);
    } catch (e) {
      /* ignore storage errors */
    }
  }, [selectedLocation]);

  const handleLogout = () => {
    api.logout().finally(() => {
      navigate("/admin/login");
    });
  };

  const navigateToSection = (section) => {
    navigate(`/admin/${selectedLocation}/${section}`);
  };

  return (
    <div className="admin-dashboard">
      <div className="admin-header">
        <div className="container">
          <div className="admin-header-content">
            <div>
              <h1 className="heading-md">Tableau de Bord Admin</h1>
              <p
                className="body-md"
                style={{ color: "var(--text-secondary)", marginTop: "0.5rem" }}
              >
                Gérez le contenu de votre site Sharp Physio
              </p>
            </div>
            <button className="btn-secondary" onClick={handleLogout}>
              <LogOut size={18} /> Déconnexion
            </button>
          </div>
        </div>
      </div>

      <section className="section">
        <div className="container">
          {/* Location Selector */}
          <div className="location-selector-admin">
            <label className="form-label">
              <MapPin size={18} /> Sélectionner un cabinet
            </label>
            <select
              className="location-select"
              value={selectedLocation}
              onChange={(e) => setSelectedLocation(e.target.value)}
            >
              {list.map((loc) => (
                <option key={loc.id} value={loc.slug}>
                  {loc.name}
                </option>
              ))}
            </select>
          </div>

          {/* Admin Cards */}
          <div className="admin-cards-grid">
            <div
              className="admin-card"
              onClick={() => navigateToSection("location")}
            >
              <div className="admin-card-icon">
                <Home size={32} />
              </div>
              <h3 className="heading-sm">Cabinet</h3>
              <p className="body-md">
                Modifier les informations du cabinet (horaires, Doctolib)
              </p>
              <button className="btn-secondary">Modifier</button>
            </div>
            <div
              className="admin-card"
              onClick={() => navigateToSection("sessions")}
            >
              <div className="admin-card-icon">
                <HeartPlus size={32} />
              </div>
              <h3 className="heading-sm">Séances</h3>
              <p className="body-md">
                Modifier les informations des séances
              </p>
              <button className="btn-secondary">Modifier</button>
            </div>
            <div
              className="admin-card"
              onClick={() => navigateToSection("team")}
            >
              <div className="admin-card-icon">
                <Users size={32} />
              </div>
              <h3 className="heading-sm">Équipe</h3>
              <p className="body-md">Gérer les membres de l'équipe</p>
              <button className="btn-secondary">Modifier</button>
            </div>

            <div
              className="admin-card"
              onClick={() => navigateToSection("gallery")}
            >
              <div className="admin-card-icon">
                <Image size={32} />
              </div>
              <h3 className="heading-sm">Galerie</h3>
              <p className="body-md">Ajouter ou supprimer des photos</p>
              <button className="btn-secondary">Modifier</button>
            </div>
            <div
              className="admin-card"
              onClick={() => navigateToSection("content")}
            >
              <div className="admin-card-icon">
                <FileText size={32} />
              </div>
              <h3 className="heading-sm">Contenu</h3>
              <p className="body-md">
                Modifier la mission, les valeurs et les services
              </p>
              <button className="btn-secondary">Modifier</button>
            </div>
          </div>

          {/* Quick Access */}
          <div className="quick-access-section">
            <h3 className="heading-md">Accès Rapide</h3>
            <div className="quick-links">
              <button
                className="quick-link-btn"
                onClick={() => navigate(`/${selectedLocation}`)}
              >
                Voir le site public
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AdminDashboard;
